export const GREMLIN_COM_DOCS_LINKS = {
  RELEASE_NOTES_GENERAL: 'https://www.gremlin.com/release-notes/general',
  RM_DETECTED_RISKS:
    'https://www.gremlin.com/docs/reliability-management-detected-risks',
  RM_SPOF:
    'https://www.gremlin.com/docs/reliability-management-dependencies#toc-marking-a-dependency-as-a-single-point-of-failure-spof',
  ROUTING_HEALTH_CHECKS:
    'https://www.gremlin.com/docs/platform-health-checks#toc-routing-health-checks-to-specific-pni-agents'
}
